import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    imports: [],
    templateUrl: './not-found.component.html',
    styles: ``
})
export class NotFoundComponent {

}
